import React, {Component} from 'react';
import {PrivateLayout} from 'components/Layouts';

class NotFound extends Component {
  render() {
    return (
      <PrivateLayout>
        <h2>Page Not Found</h2>
      </PrivateLayout>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/errors/notfound.js